<template>
    <div class="col-md-12 col-xl-12">
        <h4 class="p-b-20">Hiring Note</h4>
        <form v-on:submit.prevent="createNote">
            <div class="form-group">
                <label>Applicant Name</label>
                <input type="text" name="template_title" class="form-control" required="required" disabled="disabled" v-bind:value="applicant.firstname + ' ' + applicant.lastname" />
            </div>
            <div class="form-group">
                <label>Note</label>
                <summernote height="300" :model.sync="note.note"></summernote>
            </div>
            <div class="form-group">
                <button class="btn btn-primary btn-md">Create Note</button>
            </div>
        </form>
    </div>
</template>
<script>
import summernote from '../components/Summernote.vue'
import { bus } from '../main'

export default {
    name: 'CreateHiringNote',

    data(){
        return{
            note: {
                evaluator_id: this.$store.getters.user_data.data.id,
                note: "",
                applicant_id: "",
                company_id: this.$store.getters.user_data.data.company_id
            }, 

            applicant: [{
                firstname: '',
                lastname: ''
            }]
        }
    },

    components:{
        summernote
    },

    mounted(){
        this.note.applicant_id = this.$route.params.id
        this.getApplicant(this.$route.params.id)
        this.getPreviousNote()
    },
    methods: {
        createNote: function(){

            var note = {
                what: 'CreateHiringNote',
                data: this.note
            }

            this.$socket.makePostRequest(note)
                .then((response)=>{
                    if(response.type == "CreateHiringNote"){
                        this.$swal.fire("Success", "Note created.", 'success')

                        // setTimeout(()=>{
                        //     window.location.reload()
                        // }, 1000)
                    }
                })
                .catch((error)=>{
                    this.$swal.fire("Error", error.message, 'error')
                    console.log(error)
                })
        },


         getProcesses(){
            var stages = {
                what: 'GetProcesses'
            }

            this.$socket.makeGetRequest(stages)
                .then((response)=>{
                    if(response.type == 'GetProcesses'){
                        console.log(response)
                    }
                })
                .catch((error)=>{
                    console.log(error)
                })
        },

        getApplicant(id){
           var applicant = {
                what: "GetApplicant",
                id: id
            }

            this.$socket.makeGetRequest(applicant)
                .then((response)=>{
                    if(response.type == 'GetApplicant'){
                        console.log(response)
                        this.applicant = response.data
                    }
                })
                .catch((error)=>{
                    console.log(error)
                })

        },

        getPreviousNote(){
            var data = {
                evaluator_id: this.$store.getters.user_data.data.id,
                applicant_id: this.note.applicant_id
            }

            var prevNote = {
                what: "GetNoteForApplicant",
                data: data
            }


            this.$socket.makePostRequest(prevNote)
                .then((response)=>{
                    if(response.type == "GetNoteForApplicant"){

                        this.note.note = response.data.data[0].note

                        bus.$emit('updateText', response.data.data[0].note)

                        this.$swal.close()
                    }
                })
                .catch((error)=>{
                    //this.$swal.fire("Error", error.message, 'error')
                    console.log(error)
                })
        }
    },
    computed: {
        
    }
}
</script>